import { render, staticRenderFns } from "./PasswordSecretQuestion.vue?vue&type=template&id=fd234cb6&scoped=true&"
import script from "./PasswordSecretQuestion.vue?vue&type=script&lang=js&"
export * from "./PasswordSecretQuestion.vue?vue&type=script&lang=js&"
import style0 from "./PasswordSecretQuestion.vue?vue&type=style&index=0&id=fd234cb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd234cb6",
  null
  
)

export default component.exports